import React, { useState, FC } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';

import { FieldLabel, IFieldLabelProps, FieldError } from '../../common';
import { TDateFieldProps } from './DateField.interface';
import { useField } from 'formik';

export const DateField: FC<TDateFieldProps> = (props: TDateFieldProps): JSX.Element => {
  registerLocale('ru', ru);
  const {
    mode = 'vertical',
    name = '',
    label = '',
    disabled = false,
    placeholder = '',
    maxDate,
    minDate,
    clearBtnTitle,
  } = props;
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField(name);
  const [, setStartDate] = useState<Date | null>(null);
  const isHorizontal = mode === 'horizontal';
  const fieldProps = isHorizontal ? { as: Row } : {};
  const labelProps: IFieldLabelProps = isHorizontal
    ? {
        column: {
          mode: 'sm',
          size: 3,
        },
      }
    : {};

  // eslint-disable-next-line react/jsx-no-useless-fragment
  const wrapper = (children) => (isHorizontal ? <Col sm={9}>{children}</Col> : <>{children}</>);

  const onChange = (value: Date | null) => {
    setStartDate(value);
    if (!value) {
      setValue(undefined);
    }
  };

  const onChangeSelect = (value) => {
    setValue(value.toISOString());
    setTouched(value);

    return value.toISOString();
  };

  return (
    <Form.Group id={name} {...fieldProps}>
      <FieldLabel label={label} {...labelProps} />
      {wrapper(
        <>
          <DatePicker
            selected={value ? new Date(value) : null}
            onChange={onChange}
            dateFormat="dd.MM.yyyy"
            className="form form-control"
            locale={ru}
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            onSelect={onChangeSelect}
            disabled={disabled}
            placeholderText={placeholder}
            maxDate={maxDate}
            minDate={minDate}
            isClearable={Boolean(clearBtnTitle)}
            clearButtonTitle={clearBtnTitle}
          />
          {error && touched && <FieldError error={error} />}
        </>,
      )}
    </Form.Group>
  );
};
